import { Component } from '@angular/core';

@Component({
    selector: 'app-mainfooter',
    templateUrl: './mainfooter.component.html',
    styleUrls: ['./mainfooter.component.css']
})

export class MainFooterComponent{
}
